// extracted by mini-css-extract-plugin
export var container = "_4z-0";
export var error = "_4z-9";
export var label = "_4z-5";
export var light = "_4z-6";
export var md = "_4z-3";
export var sm = "_4z-2";
export var thin = "_4z-8";
export var thinBold = "_4z-7";
export var vertical = "_4z-4";
export var xs = "_4z-1";